function sliderBanner() {
    const swiperContainer = document.querySelector('.banner_swiper-js');
    if (!swiperContainer) return;

    const swiper = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        autoplay: {
            delay: 3000,
            speed: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.banner_swiper_pagination',
            clickable: true,
        },
        navigation: {
            nextEl: ".banner_next",
            prevEl: ".banner_prev",
        },
    });
}

function sliderBannerHero() {
    const swiperContainer = document.querySelector('.banner_hero_swiper-js');
    if (!swiperContainer) return;

    new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.banner_hero_pagination',
            clickable: true,
        },
    });
}

document.addEventListener('DOMContentLoaded', function () {
    sliderBanner();
    sliderBannerHero();
});